module.exports = __webpack_public_path__ + "images/emoji/eight_pointed_black_star.8c753839ca4fed0ead7e.png";